export default __webpack_public_path__ + "static/Litepaper - Spanish-bc51f996b7e34c638e627c4e9190d1a9.pdf";